<template>
    <div class="audit">
        <div class="editCallOutcomeSection">
            <h3>Call Outcome</h3>
            <label>{{ condensedOptions }}</label>

            <div class="callOutcomeSlide">
                <div v-if='!call.islive'>
                    <p>{{ category.hc_question }}</p>
                    <div class='callOutcomeSlideOptions'>
                        <CheckboxWrap v-for="option in options" :inputID="option.hcat_optionid" :labelText="option.option_display" :useSmallLabel="true" :key="option.hcat_optionid">
                            <template v-slot:input>
                                <input :id='option.hcat_optionid' :value='option.hcat_optionid' v-model='selectedOption' type="radio">
                            </template>
                        </CheckboxWrap>
                    </div>
                    <div class='buttonWrap'>
                        <button class='alt' :disabled="reviews.length == 0" @click="prev()">Previous</button>
                        <button class="alt" :disabled="!selectedOption || finishedReview" @click="next(category.hcatid)">Next</button>
                    </div>
                </div>
                <p v-else>Call is currently live.</p>
            </div>
        </div>

        <div class="editCallRecapSection">
            <h3>Recap</h3>
            <div class="recapSectionText">
                <textarea v-model='recap' rows="5" cols="50" placeholder="Enter recap here..."></textarea>
            </div>
        </div>

        <div class='saveButton'>
            <button @click='saveEditInfo()'>Save</button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import CheckboxWrap from '@/components/CheckboxWrap';

export default {
    name: 'Audit',
    props: ["call", "transcript", "messageindex"],
    components: { CheckboxWrap },
    data: function () {
        return {
            selectedOption: false,
            category: {
                hcatid: false,
                hc_question: ''
            },
            categoryCache: [],
            options: [],
            filters: [],
            reviews: [],
            recap: this.transcript,
            condensedOptions: this.call.disposition_condensed,
            finishedReview: false
        }
    },
    computed: {
        ...mapState({
            user: state => state.user,
            currentHproduct: state => state.currentHproduct
        })
    },
    mounted: function () {
        this.getContingentCategory(this.selectedOption);
        this.recap = this.transcript;
    },
    methods: {
        getContingentCategory: async function (optionid) {
            let endpoint = `/hcatContingency/`;
            if (optionid) {
                endpoint += optionid;
            }
            endpoint += `?line=${this.call.cf_frn_dnisid}`;
            endpoint += `&extension=${this.call.extension_frn_dnisid}`;
            endpoint += `&callid=${this.call.callid}`;
            endpoint += `&hproduct=${this.currentHproduct}`;
            
            let res = await this.axios.get(endpoint, { responseType: 'json' });

            if (res.data.category) {
                this.category = res.data.category;
                this.options = res.data.options;
                this.filters = res.data.filters;
            } else {
                let message = res.data.message == "no contingencies for option"
                    ? `You've finished auditing this call. Click 'SAVE' to submit.`
                    : res.data.message == "line is not eligible for review."
                        ? `This line is not eligible for review.`
                        : 'An error occurred. Please try again later.';
                this.category = { 
                    hcatid: false, 
                    hc_question: message
                };
                this.options = [];
                this.finishedReview = true;
            }
        },
        submitEdits: async function () {
            let endpoint = `/calls/${this.call.callid}/audit`;
            let res = await this.axios.post(endpoint, {
                reviews: this.reviews,
                summary: this.recap,
                uid: this.user.leuserid
            });

            this.$parent.$emit('dispositionCondensed', this.condensedOptions);

            if (res.data) {
                if (res.data.updatedUnaddressed) {
                    this.$parent.$emit('toggleUnaddressed', {
                        unaddressed: res.data.unaddressed,
                        index: this.messageindex,
                        datetime: this.call.tz_datetime
                    })
                }
            }
        },
        next: function (currentCategory) {
            let review = { 
                hcatid: currentCategory, 
                optionid: this.selectedOption 
            };
            this.categoryCache.push({
                category: this.category, 
                options: this.options
            });
            
            if (this.selectedOption) {
                // check if override option
                let op = this.options.find((option) => {
                    return option.hcat_optionid == this.selectedOption;
                });
                let filter = this.filters.find((filter) => {
                    return filter.hcat_optionid == this.selectedOption;
                });
                if (!this.reviews.length) {
                    this.condensedOptions = '';
                }
                this.condensedOptions += this.condensedOptions == ''
                     ? `${filter.reporting_filter}`
                     : `, ${filter.reporting_filter}`;
                if (op.hco_override) {
                    let overrideCategory = op.HcatOverrides[0].hcat_eligible_override;

                    // go back to that category
                    let reviewIndex = this.reviews.findIndex(
                        (review => review.hcatid == overrideCategory)
                    );
                    this.reviews = this.reviews.slice(0, reviewIndex + 1);

                    let cacheIndex = this.categoryCache.findIndex(
                        (cache => cache.category.hcatid == overrideCategory)
                    );
                    this.categoryCache = this.categoryCache.slice(0, cacheIndex + 1);

                    this.condensedOptions = '';

                    this.category = this.categoryCache[this.categoryCache.length - 1].category;
                    this.options = this.categoryCache[this.categoryCache.length - 1].options;
                    this.selectedOption = false;

                    return;
                }
            }

            this.getContingentCategory(this.selectedOption);
            this.selectedOption = false;
            this.reviews.push(review);
        },
        prev: function () {
            this.selectedOption = false;
            this.reviews.pop();
            let index = this.condensedOptions.lastIndexOf(',');
            this.condensedOptions = index !== -1
                ? this.condensedOptions.slice(0, index)
                : '';
            let previous = this.categoryCache.pop();
            this.category = previous.category;
            this.options = previous.options;
        },
        saveEditInfo: function () {
            this.category = { 
                hcatid: false, 
                hc_question: `Submitting...`
            };
            this.submitEdits();
            this.$emit('edited-call');
 	    }
    }
}
</script>